import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class premiumFeatureModal_template extends vnTemplate {

    /** @inheritDoc */
    protected getTemplateHtml(): string{

        return `
                
            <div class="w-dialog plus theme-dark" data-bind="css: { 'is-visible': isVisible }, event: { click: onBackgroundClickClose }">
                <div class="dialog-container">
                    <div class="dialog-inner">
                        <aside class="dialog-aside">
                            <div class="dialog-aside-brand plus-shadow-glow-neutral">
                                <img src="/assets/images/plus-app-icon.png" width="64" height="auto" />
                            </div>
                            <h3 class="dialog-aside-title">
                                <!-- ko if: feature() === 'events' -->
                                    Get the most out of SentinelPro with <span class="plus-text-shimmer-accent">Events Overview</span>
                                <!-- /ko -->
                                <!-- ko if: feature() === 'api' -->
                                    Get the most out of SentinelPro with <span class="plus-text-shimmer-accent">API Access</span>
                                <!-- /ko -->
                            </h3>
                            <p class="dialog-aside-subtitle">
                                <!-- ko if: feature() === 'events' -->
                                    Get access to events overview, long term data, API access, and more by upgrading your subscription.
                                <!-- /ko -->
                                <!-- ko if: feature() === 'api' -->
                                    Get API access, events overview, long term data and more by upgrading your subscription.
                                <!-- /ko -->
                            </p>
                        </aside>
                        <button type="button" class="dialog-dismiss icon i-close" data-bind="event: { click: onClickClose }"><span class="hide">close</span></button>
                        <div class="dialog-body theme-light">
                            <div class="dialog-body-title">
                                <h4>Upgrade your Subscription</h4>
                                <!-- ko if: isOwner() -->
                                    <p>
                                        This feature is only available on paid plans. As the account owner, you can upgrade your plan to unlock access for your team.
                                    </p> 
                                <!-- /ko -->
                                <!-- ko ifnot: isOwner() -->
                                    <p>
                                        This feature is only available on paid plans.
                                    </p>       
                                <!-- /ko -->
                            </div>
                            <div class="feature">
                                <h5 class="feature-title">What's included</h5>
                                <ul class="feature-list">
                                    <li>More Hits per Month</li>
                                    <li>Long Term Data</li>
                                    <li>API</li>
                                    <li>Unlimited features</li>
                                    <li>Unlimited properties</li>
                                    <li>Exports</li>
                                    <li>Custom events</li>
                                </ul>
                            </div>
                        </div>
                        <div class="dialog-footer theme-light">
                            <a class="plus-btn subtle" href="https://sentinelpro.com/pages/pricing" target="_blank">Learn More</a>
                            <!-- ko if: isOwner() -->
                                <a class="plus-btn" data-bind="attr: { href: '/subscription_management/'}, event: { click: onClickClose }, text: 'Upgrade'"></a>
                            <!-- /ko -->
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    /** @inheritDoc */
    protected initPartial(): void{

    }

    /** @inheritDoc */
    protected getTemplateName(): string{

        return 'premiumFeatureModal_template';
    }

    /** @inheritDoc */
    protected getMainElementClasses(): Array<string>{

        return [];
    }

    /** @inheritDoc */
    public buildViewModel(): Object{

        let self = this;

        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape') {
                self.handleEscape();
            }
        });

        return {
            isVisible: ko.observable(false),
            feature: ko.observable('events'),
            isOwner: ko.observable(true),
            onClickClose: function(){ return self.onClickClose(); },
            onBackgroundClickClose: function(data, event){ return self.onBackgroundClickClose(data, event); }
        };
    }

    public handleEscape() {
        
        this.hide();
    }

    public setIsOwner(isOwner: boolean){

        this.getTemplateViewModel().isOwner(isOwner);
    }

    public setFeature(feature: string){

        this.getTemplateViewModel().feature(feature);
    }

    //
    // Returns true if modal is visible.
    public isVisible(){

        this.getTemplateViewModel().isVisible();
    }

    //
    // Show modal.
    public show(){

        this.getTemplateViewModel().isVisible(true);
    }

    //
    // Hide modal.
    public hide(){

        this.getTemplateViewModel().isVisible(false);
    }

    //
    // Handles on close button click event.
    public onClickClose(){

        this.hide();

        return true;
    }

    //
    // Handles background click event.
    public onBackgroundClickClose(data, event){
        
        if (event.target === event.currentTarget) {
            
            this.hide();
        }
        return true;
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/premiumFeatureModal_template.ts